import { getRoot, types } from 'mobx-state-tree'
import { DateString, RootModel } from '@shared/data-access'
import { ConversationRoom } from '../conversation-room'

export const MODEL_NAME = 'ConversationParticipants'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    unreadMessagesCount: types.maybeNull(types.number),
    lastReadDate: types.maybeNull(DateString),
    conversation: types.maybeNull(types.reference(ConversationRoom)),
  })
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))
  .actions((self) => ({
    updateUnreadMessages(count) {
      self.unreadMessagesCount = count
      self.save()
    },
  }))
